module.exports = __webpack_public_path__ + "static/media/create_lightbox.4f584cba.svg";